import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiApp} from "./UiApp";
import {redirect} from "../../utils";

export class UiNotLoggedInfo extends MuWidget {
    // @ts-ignore
    muParent: UiApp;
    beforeIndex() {
        this.muAppendContent(`<div class="c-message">
            <h2>Vítej v aplikaci FitKOnotes</h2>
            <p>Ahoj! Chceš mít lepší výsledky a potřebuješ vedení na své cestě za zdravějším životním stylem? Se mnou to zvládneš! Jako první je potřeba aby ses 
                <span class="btn--primary d-block w-100p" mu="bSign">přihlásil</span>
            zabere to jen chviku</p>
        </div>`);
    }

    bSign_click() {
        redirect(this.muParent.signUrl);
    }
}